const BASE_URL = process.env.VUE_APP_BASE_URL //  基础的URL
const TIME_OUT = process.env.TIME_OUT // 超时时间
export { BASE_URL, TIME_OUT }
